import { useState } from 'react';
import Modal from '../elements/Modal';
import Button from '../forms/Button';
import { classNames } from '../../helpers/classNames';

const BookSelectionModal = ({ 
  isOpen, 
  setIsOpen, 
  books = [], 
  onBookSelect = () => {} 
}) => {
  const [selectedBookId, setSelectedBookId] = useState(null);

  const handleBookSelection = (bookId) => {
    setSelectedBookId(bookId);
  };

  const handleDone = () => {
    if (selectedBookId) {
      console.log('Selected book ID:', selectedBookId);
      onBookSelect(selectedBookId);
      setIsOpen(false);
      setSelectedBookId(null); // Reset selection
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedBookId(null); // Reset selection when closing
  };

  return (
    <Modal
      title="Select a Book"
      subtitle="Choose one book from the list below"
      isOpen={isOpen}
      setIsOpen={handleClose}
      size="lg"
      modalDialogueStyle=""
      bodyClasses="max-h-96 overflow-y-auto"
    >
      <div className="space-y-3">
        {books.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-slate-500">No books available</p>
          </div>
        ) : (
          books.map((book) => (
            <div
              key={book._id}
              onClick={() => handleBookSelection(book._id)}
              className={classNames(
                "p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 hover:shadow-md",
                selectedBookId === book._id
                  ? "border-md-pink bg-md-pink/5 shadow-sm"
                  : "border-gray-200 hover:border-md-pink/50"
              )}
            >
              <div className="flex items-start space-x-4">
                {/* Book Cover Placeholder */}
                <div className="flex-shrink-0">
                  {!!book.coverImage?.url ? (
                    <img
                      src={book.coverImage.url}
                      alt={book.title}
                      className="w-12 h-16 object-cover rounded border"
                    />
                  ) : (
                    <div className="w-12 h-16 bg-gray-200 rounded border flex items-center justify-center">
                      <i className="fa-regular fa-book text-gray-400 text-lg"></i>
                    </div>
                  )}
                </div>

                {/* Book Details */}
                <div className="flex-grow min-w-0">
                  <h3 className="font-semibold text-md-dark truncate">
                    {book.title}
                  </h3>
                  <p className="text-sm text-slate-500 mt-1 line-clamp-2">
                    {book.description}
                  </p>
                  <p className="text-xs text-slate-400 mt-2">
                    Created: {new Date(book.createdAt).toLocaleDateString()}
                  </p>
                </div>

                {/* Selection Indicator */}
                <div className="flex-shrink-0">
                  {selectedBookId === book._id ? (
                    <div className="w-6 h-6 bg-md-pink rounded-full flex items-center justify-center">
                      <i className="fa-solid fa-check text-white text-sm"></i>
                    </div>
                  ) : (
                    <div className="w-6 h-6 border-2 border-gray-300 rounded-full"></div>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end space-x-3 mt-6 pt-4 border-t border-gray-200">
        <Button
          buttonLabel="Cancel"
          buttonClasses="!bg-gray-100 !text-gray-700 !border-gray-200 hover:!bg-gray-200"
          buttonFunction={handleClose}
        />
        <Button
          buttonLabel="Done"
          buttonClasses={classNames(
            "!bg-md-pink !text-white !border-md-pink hover:!bg-md-pink-dark",
            !selectedBookId && "!opacity-50 !cursor-not-allowed"
          )}
          buttonFunction={handleDone}
          disabled={!selectedBookId}
        />
      </div>
    </Modal>
  );
};

export default BookSelectionModal;